import type { TransformFunctions } from '@sitecore/common';

export const businessUnit = 'nl';
export const countryCode = 'NL';
export const label = 'eneco';
export const name = 'nl-eneco-zakelijk';
export const uuid = 'HINok3';
export const transformFunctions: TransformFunctions = {};
